import { render, staticRenderFns } from "./dataForm.vue?vue&type=template&id=1c8d469c&scoped=true&"
import script from "./dataForm.vue?vue&type=script&lang=js&"
export * from "./dataForm.vue?vue&type=script&lang=js&"
import style0 from "./dataForm.vue?vue&type=style&index=0&id=1c8d469c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c8d469c",
  null
  
)

export default component.exports